<!-- 员工管理-权限分配 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea AuthAllot">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">

        <!--权限选择-->
        <el-tree
          class="allotTree"
          ref="tree"
          :data="treeData.access_list"
          show-checkbox
          node-key="function_id"
          :default-checked-keys="treeData.user_access_list"
          :props="treeData.defaultProps"
          default-expand-all>
        </el-tree>

        <!-- 确认 -->
        <el-button
          class="confirm"
          type="primary"
          @click="getCheckedKeys"
          v-if="treeData.access_list.length !== 0">确 认</el-button>

      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import {
    showToast
  } from "../../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../../static/js/api.js"

  export default {
    name: 'AuthAllot',
    components: {
      BreadCrumb
    },
    data() {
      return {
        treeData: {
          // 权限列表
          access_list: [],
          // 	用户已选权限
          user_access_list: [],
          defaultProps: {
            children: 'children',
            label: 'function_name'
          }
        }
      }
    },
    mounted(){
      console.log('', this.$route.query.user_id)
      this.getStaffAuthList()
    },
    created: async function () {
    },
    methods: {
      // 数据处理
      processData: function (data) {
        this.treeData.access_list = data.access_list
        this.treeData.user_access_list = data.user_access_list
        console.log('权限列表', this.treeData.access_list)
      },
      // 获取员工权限列表
      getStaffAuthList: async function () {
        let vm = this
        let data = {
          user_id: this.$route.query.user_id
        }

        let res = await systemApi.getStaffAuthList(data)
        if (res.meta.code === 200) {
          // console.log('权限列表', res.data)
          vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 新增员工权限
      addStaffAuth: async function (accessList) {
        let vm = this
        let data = {
          user_id: this.$route.query.user_id,
          accessList: accessList
        }

        let res = await systemApi.addStaffAuth(data)
        if (res.meta.code === 200) {
          showToast('权限分配成功')
          // 返回上一页
          setTimeout(function () {
            vm.$router.go(-1)
          }, 1000)
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认新增
      getCheckedKeys() {
        // console.log(this.$refs.tree.getCheckedKeys());
        let accessList = this.$refs.tree.getCheckedKeys()
        this.addStaffAuth(accessList)
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .authChoose {
    margin: 3%;
  }
  .classChoose {
    margin: 3%;
  }
  .addButton {
    margin: 3%;
  }
  .confirm {
    margin: 30px 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Page/System/StaffManage/AuthAllot.vue